import ApproveBusinessModal from 'components/BusinessesSection/dialogs/ApproveBusinessModal/ApproveBusinessModal';
import BusinessesTable from './table/BusinessesTable';
import RejectBusinessModal from 'components/BusinessesSection/dialogs/RejectBusinessModal';
import { BusinessProvider } from 'context/businesses/businessContext';

const BusinessesSection = () => {
    return (
        <BusinessProvider>
            <BusinessesTable />
            <ApproveBusinessModal />
            <RejectBusinessModal />
        </BusinessProvider>
    );
};

export default BusinessesSection;
